module.exports = __webpack_public_path__ + "img/survey.74efc43c.jpeg";